import { useEffect } from 'react'

const useOutsideClick = (refs, callback) => {
	const handleClick = (e) => {
		// every() testa se todos os elementos do array passam pelo teste implementado
		// pela função fornecida. Este método retorna um valor booleano.
		const isOutsideClick = refs.every(
			(ref) => ref.current && !ref.current.contains(e.target)
		)
		if (isOutsideClick) {
			callback()
		}
	}

	useEffect(() => {
		document.addEventListener('click', handleClick)

		return () => {
			document.removeEventListener('click', handleClick)
		}
	})
}

export default useOutsideClick
